import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import { renderStars } from '../../helpers/reviewHelper';
import '../products/productdetails.css'
//apis 
import { getProduct, getIdBySlug, getProductBySchool } from '../../api/productapi';
//helpers
import { updateTitle } from '../../helpers/titleHelper';
import { formatUSD } from '../../helpers/formatterHelper';
import { checkForDistrictId } from '../../helpers/checkForDistrictId';
//reducers
import { loadAllItems } from '../../store/myproject-reducer';
//components
import Banner from '../../components/common/ShowBannerDetails';
import Breadcrumbs from '../../components/common/BreadCrumb';
import { AccordionItem } from '../../components/common/Accordion';
import { ProductGallery } from '../../components/common/ProductGallery';
import Review from '../review/index';
import { getReviewerTypes } from '../../store/reviews/actions';
import { ProductOptions } from '../products/productOptions';
import { getById } from '../../api/typicallayoutsapi';
import { getSchoolProductsBySchoolId } from "../../api/schoolsApi";

export default function TypicalLayoutProductReview() {
    const scrollRef = useRef(null);
    const productOptionRef = useRef(null);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const isPreview = location.pathname.includes('/preview');
    const { id, slug, cartId, typicalId, schoolId } = useParams();
    const [productId, setProductId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [product, setProduct] = useState({});
    const [productDetails, setProductDetails] = useState({});
    const [productOptions, setProductOptions] = useState({});
    const [productLine, setProductLine] = useState([]);
    const [updatedProduct, setUpdatedProduct] = useState(null);
    const [updatedPrice, setUpdatedPrice] = useState(0);
    const [isRequired, setIsRequired] = useState(null);
    const { reviewTypes } = useSelector((state) => state.reviews);
    const { selectedSchool } = useSelector((state) => state.schools);
    const myProjectItems = useSelector((state) => state.myProject.data.items);
    const queryParams = new URLSearchParams(location.search);
    const { siteUserId } = useSelector((state) => state.auth);
    const getCartId = parseInt(cartId);
    const typicalViewId = parseInt(typicalId);
    let istypicalLayoutProduct = localStorage.getItem('isTypicallayoutProduct');
    let gettypicalLayoutitems = localStorage.getItem('editTypicalLayout');

    const effectiveSchoolId = schoolId || selectedSchool;
    const pathParts = location.pathname.split('/').filter(Boolean);
    const isReview = pathParts[pathParts.length - 1] === 'review';

    const isTypicallayout =
        pathParts.length === 8 &&
        pathParts[1] === 'products' &&
        isReview;

    let TypicalDetailList = "";
    if (gettypicalLayoutitems != undefined && gettypicalLayoutitems != null && gettypicalLayoutitems != '') {
        TypicalDetailList = JSON.parse(gettypicalLayoutitems);
    }
    var district = {};
    const districtJson = localStorage.getItem('district') ?? '';
    if (districtJson != '') {
        district = JSON.parse(districtJson);
    }
    const [layoutId, setLayoutId] = useState(typicalId);
    const [schoolProducts, setSchoolProducts] = useState([]);


    const getSchoolProducts = async (schoolId) => {
        try {
            const response = await getSchoolProductsBySchoolId(schoolId);
            const { success, data } = response?.data || {};
            if (success) {
                setSchoolProducts(data?.map(item => item.productId) ?? []);
            }
        } catch (error) {
            console.error('An unknown error occurred while fetching school products.:', error);
        }
    }

    useEffect(() => {
        getSchoolProducts(selectedSchool)
    }, [selectedSchool]);

    useEffect(() => {
        dispatch(getReviewerTypes());
        setLayoutId(typicalId)
    }, [dispatch])


    useEffect(() => {
        if (slug != null && slug != '') {
            getIdBySlug(slug).then(response => {
                if (response.data.success == true) {
                    setProductId(response.data.data);

                } else {
                    if (parseInt(slug) != 'NaN') {
                        setProductId(parseInt(slug));
                    }
                }
            });
        }
    }, [slug])

    useEffect(() => {
        if (!productId || !layoutId) return;
        const fetchData = async () => {
            try {
                const layoutRes = await getById(layoutId);
                if (layoutRes?.data?.success) {
                    const responseData = layoutRes.data.data;
                    const addedProducts = responseData.products.map(pro => ({
                        ...pro,
                        isAdded: schoolProducts.includes(pro.productId)
                    }));

                    // cartId match hone par localStorage mein save
                    if (cartId) {
                        const filteredProducts = addedProducts.filter(product =>
                            product.id === parseInt(cartId)
                        );
                        localStorage.setItem('typicalLayoutProductDetail', JSON.stringify(filteredProducts));
                    }
                }

                const typicalProductDetails = JSON.parse(localStorage.getItem('editTypicalLayout')) || [];
                let districtID = typicalProductDetails?.districtId || localStorage.getItem('districtId');

                if (typicalViewId) {
                    dispatch(loadAllItems("typicalProductDetailView"));
                } else if (TypicalDetailList) {
                    districtID = TypicalDetailList.districtId;
                }

                if (isPreview) {
                    const productRes = await getProduct(productId);
                    handleResponse(productRes);
                } else {
                    checkForDistrictId(navigate);
                    const productRes = await getProductBySchool(districtID, effectiveSchoolId, id, isTypicallayout, cartId);
                    handleResponse(productRes);
                }
            } catch (err) {
                handleError(err);
            } finally {
                handleFinally();
            }
        };

        fetchData();
    }, [productId, layoutId, isPreview, schoolProducts]);


    useEffect(() => {
        var setupProduct = { ...product };
        if (updatedProduct != null) { setupProduct = updatedProduct; }
        if (setupProduct && setupProduct.options) {
            setupProduct.options = setupProduct.options.map((option) => {
                if (option.items.length === 1 && !queryParams.get('cartid')) {
                    return {
                        ...option,
                        items: [option.items[0]],
                    };
                } else {

                    return {
                        ...option,
                        items: [],
                    };
                }

            });
            setUpdatedProduct(setupProduct);
        }
    }, [product]);

    useEffect(() => {
        const calculateTotalUpcharge = (options) => {
            return options.reduce((acc, option) => {
                const optionUpcharge = option.items.reduce(
                    (innerAcc, item) => innerAcc + (item.upCharge === undefined || item.upCharge === null ? 0 : item.upCharge),
                    0
                );
                return acc + optionUpcharge;
            }, 0);
        };

        const calculateDiscountedPrice = (price, discount) => {
            return price - (discount > 0 ? price * (discount / 100) : 0);
        };

        if (updatedProduct?.options?.length > 0) {
            const { options } = updatedProduct;
            const { price, discount } = productDetails;

            const totalUpCharge = calculateTotalUpcharge(options) + price;
            const totalPrice = calculateDiscountedPrice(totalUpCharge, discount);
            setUpdatedPrice(totalPrice);
        } else if (productDetails?.price) {
            const { price, discount } = productDetails;

            setUpdatedPrice(calculateDiscountedPrice(price, discount));
        }

        if (productDetails.discount !== undefined) {
            sessionStorage.setItem('productDiscount', productDetails.discount);
        } else {
            sessionStorage.setItem('productDiscount', 0);
        }

    }, [updatedProduct, productDetails]);


    const handleResponse = (response) => {
        setProduct(response.data.data);
        setProductDetails(response.data.data.details);
        setProductOptions(response.data.data.options);
        setProductLine(response.data.data.productLine);

        updateTitle('Product', response.data.data.details.name);
    };

    const isSameOptionSelected = (items, option) => {
        return items.length > 0 && items[0].id === option.id;
    };

    const handleMultiSelection = (items, option) => {
        const itemIndex = items.findIndex((item) => item.id === option.id);
        if (itemIndex !== -1) {
            const newItems = [...items];
            newItems.splice(itemIndex, 1);
            return newItems;
        }
        return [...items, option];
    };

    const handleSingleSelection = (items, option) =>
        isSameOptionSelected(items, option) ? [] : [option];

    const updateOptionSelection = (currentOptions, option, type) => {
        const updatedOptions = currentOptions.options.map((optGroup) => {
            if (optGroup.type !== type ||
                option.productOptionId != optGroup.id) {
                return optGroup;
            }

            const updatedItems = (() => {
                switch (type) {
                    case 3:
                        return handleMultiSelection(optGroup.items, option);
                    case 2:
                        return optGroup.colorGroupId === option.color.colorGroupId
                            ? handleSingleSelection(optGroup.items, option)
                            : optGroup.items;
                    default:
                        return handleSingleSelection(optGroup.items, option);
                }
            })();
            return {
                ...optGroup,
                items: updatedItems,
            };
        });
        return {
            ...currentOptions,
            options: updatedOptions,
        };
    };

    const handleOptionSelection = (option, type) => {
        const currentOptions = { ...updatedProduct };
        const newProduct = updateOptionSelection(currentOptions, option, type);
        setUpdatedProduct(newProduct);
        if (isRequired != null) {
            const updaterequired = isRequired.filter(obj => obj.id !== option.productOptionId);
            setIsRequired(updaterequired);
        }
    };

    const handleError = (err) => {
        setError('Error fetching product: ' + err);
    };

    const handleFinally = () => {
        setIsLoading(false);
    };


    useEffect(() => {
        let debounceTimer;
        clearTimeout(debounceTimer);
        const htmlContent = productOptionRef.current;

        const getProductOptions = myProjectItems.find((item) => item.cartId === getCartId);
        if (getProductOptions != null && getProductOptions != undefined) {
            getProductOptions.options.map((option) => {
                var selectedOption = product?.options?.find((x) => x.id === option.id);
                if (selectedOption != undefined && selectedOption != null) {
                    option.items.map((selectedItem) => {
                        var selectedDetail = selectedOption?.items.find((x) => x.id === selectedItem.id);
                        if (selectedDetail != undefined && selectedDetail != null) {
                            if (selectedOption.type == 0 || selectedOption.type == 1) {
                                debounceTimer = setTimeout(() => {
                                    if (!isLoading) {
                                        const itemWidth = htmlContent.querySelector('[data-action="productwidth"][id="' + selectedDetail?.id + '"]');
                                        itemWidth.click();
                                    }
                                }, 100);
                            }
                            else if (selectedOption.type == 2) {
                                debounceTimer = setTimeout(() => {
                                    if (!isLoading) {
                                        const itemColor = htmlContent.querySelector('[data-action="color"][id="' + selectedDetail?.colorId + '"]');
                                        itemColor.click();
                                    }
                                }, 100);
                            }
                            else if (selectedOption.type == 3 || selectedOption.type == 4) {
                                debounceTimer = setTimeout(() => {
                                    if (!isLoading) {
                                        const itemDimensions = htmlContent.querySelector('[data-action="dimensions"][id="' + selectedDetail?.id + '"]');
                                        itemDimensions.click();
                                    }
                                }, 100);
                            }
                        }
                    });
                }
            });
        }
    }, [isLoading, myProjectItems]);

    if (isLoading) {
        return <h1 className="loading-data">Loading...</h1>;
    }

    if (((typicalViewId != undefined && typicalViewId != null && typicalViewId != '') || (TypicalDetailList != undefined && TypicalDetailList != null && TypicalDetailList != '')
        || (istypicalLayoutProduct != undefined && istypicalLayoutProduct != null && istypicalLayoutProduct != '')) && error) {
        return (<div style={{ "width": '100%', 'max-width': '800px', 'margin': 'auto' }}>
            <h2>
                This product is not part of your current organization&apos;s standard,
                but we can select a similar replacement.
            </h2>
            <p style={{ 'padding-top': '2rem' }}>
                Contact Facility Standard at <b>(816)-768-6179</b> for a similar product replacement recommendation.
            </p>
            <p style={{ 'padding-top': '2rem' }}><Link to="/contact">Contact Us</Link></p>
        </div>)
    }
    else if (error) {
        return <h1 className="loading-data">Product is not available</h1>;
    }

    if (!productDetails.name) {
        return <h1 className="loading-data">No Product found</h1>;
    }

    return (
        <>
            <Banner />
            <div className="product-deatis-page-wrap">
                <div className='product-sticky-bar'>
                    <div className='default-center'>
                        <p className="product-detail-price">
                            <span className="product-detail-price-amount">
                                {formatUSD(updatedPrice)}
                            </span>{' '}
                            {!isPreview ? "District Contract Price" : ""}
                        </p>
                        {product && product.media && product.media.length > 0 && (
                            <div className='product-img'>
                                {(() => {
                                    const imageItem = product.media.find(item =>
                                        !item?.mediaItem?.previewsrc?.includes("/static/media/")
                                    );
                                    return imageItem ? (
                                        <img src={imageItem.mediaItem.previewsrc} alt={product.details.name} />
                                    ) : null;
                                })()}
                            </div>
                        )}

                    </div>
                </div>
                <div className="default-outer-wrapper product-details-default-wrap">
                    <div className="desktop-gallery">
                        <div className="default-center">
                            <div className="product-header-wrap">
                                <Breadcrumbs
                                    productName={productDetails.name}
                                    category={product.categories}
                                />
                            </div>
                        </div>


                    </div>
                    <div className="default-center">
                        <div className="product-header-wrap">
                            <div className="product-detail-inner">
                                <div className="product-detail-left">

                                    {product && product.media && product.media.length > 0 ? (
                                        <ProductGallery
                                            images={product.media.filter(item => !item?.mediaItem?.previewsrc?.includes("/static/media/"))}
                                            alt={product.details.name} />
                                    ) : (
                                        <div className="product-info-gallery-wrap prod-bottom comming-soon-img-gallery">
                                            <div className="product-gallery-info-inner">
                                                <div className="product-gallery-thumb-row thamb-galler-comming-soon">
                                                    <div className="slick-slider slick-initialized">
                                                        <div className="slick-list">
                                                            <div className="slick-track slick-comming-soon-img">
                                                                <div data-index="0" className="slick-slide slick-active slick-current" aria-hidden="false">
                                                                    <div><div className="product-gallery-thumb-column">
                                                                    </div></div></div></div></div></div></div>
                                                <div className="product-gallery-slider-img-wrap">
                                                    <div className="slick-slider product-gallery-container slick-initialized">
                                                        <div className="slick-list">
                                                            <div className="slick-track">
                                                                <div data-index="0" className="slick-slide slick-active slick-current reponsive-width" aria-hidden="false">
                                                                    <div className="images-comming-soon-left">
                                                                        <div className="product-gallery-slide">
                                                                            <div className="product-gallery-image-wrap comming-soon-wrap">
                                                                                <span className="product-gallery-title-wrap"><span className="errorImage">Image Coming Soon</span></span>
                                                                            </div>
                                                                            <div className="product-gallery-caption-container">
                                                                                <p className="product-gallery-caption">Image may not depict the actual color selected</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    )}

                                    <div className="mobile-heading">
                                        <div className="default-center">
                                            <div className="product-header-wrap">
                                                <div className="product-detail-inner">
                                                    <div className="product-detail-right">
                                                        <p className="product-credit-desc">
                                                            {productLine &&
                                                                productLine.manufacturer &&
                                                                productLine.manufacturer.name}{' '}
                                                            #{productDetails.freedomCode}
                                                            <span className="product-detail-icon-wrap"></span>
                                                        </p>
                                                        <p className="product-detail-title">
                                                            {productDetails.name}
                                                        </p>
                                                        <p className="product-detail-price">
                                                            <span className="product-detail-price-amount">
                                                                {formatUSD(updatedPrice)}
                                                            </span>{' '}
                                                            {!isPreview ? "(District Contract Price)" : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="product-detail-right" ref={scrollRef}>
                                    <div className="product-detail-desktop-heading">
                                        <p className="product-credit-desc">
                                            {productLine &&
                                                productLine.manufacturer &&
                                                productLine.manufacturer.name}{' '}
                                            #{productDetails.freedomCode}
                                            <span className="product-detail-icon-wrap"></span>
                                        </p>
                                        <h1 className="product-detail-title">{productDetails.name}</h1>
                                        {district?.isReviewVisible && (
                                            <div className='total-rating'>
                                                <span>{(product?.averageRating ?? 0).toFixed(1)}</span>&nbsp;
                                                <span>{renderStars(product?.averageRating)}</span>&nbsp;
                                                <span>
                                                    {product?.reviewCount} rating{product?.reviewCount > 1 ? "s" : ""}
                                                </span>
                                            </div>
                                        )}
                                        <p className="product-detail-price">
                                            <span className="product-detail-price-amount">
                                                {formatUSD(updatedPrice)}
                                            </span>{' '}
                                            {!isPreview ? "(District Contract Price)" : ""}
                                        </p>
                                    </div>
                                    <div
                                        className="product-detail-list"
                                        dangerouslySetInnerHTML={{
                                            __html: productDetails.shortDescription,
                                        }}
                                    ></div>


                                    {/*options section */}
                                    {productOptions && (
                                        <ProductOptions
                                            options={productOptions}
                                            handleOptionSelection={handleOptionSelection}
                                            requiredOption={isRequired}
                                            productOptionRef={productOptionRef}
                                        />
                                    )}
                                    {/* @*accoridon section*@ */}
                                    <div className="prod-detail-content-wrap">
                                        {productDetails && productDetails.description && (
                                            <AccordionItem title="Description">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: productDetails.description,
                                                    }}
                                                ></p>
                                            </AccordionItem>
                                        )}
                                        {productDetails && productDetails.specifications && (
                                            <AccordionItem title="Size and Specifications">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: productDetails.specifications,
                                                    }}
                                                ></p>
                                            </AccordionItem>
                                        )}
                                        {product.documents && product.documents.length > 0 && (
                                            <AccordionItem title="Manufacturer Guides">
                                                {product.documents.map((docs) => {
                                                    return (
                                                        <a
                                                            key={docs.id}
                                                            href={'/api/media/pdf/' + product.id + '/' + encodeURI(docs.fileName)}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <p> {docs.title}</p>
                                                        </a>
                                                    );
                                                })}
                                            </AccordionItem>
                                        )}
                                        {district?.isReviewVisible && (
                                            <Review productId={parseInt(productDetails?.productId)} productName={productDetails?.name} productImageUrl={product.media?.filter(item => !item?.mediaItem?.previewsrc?.includes("/static/media/"))[0]?.mediaItem?.previewsrc} district={district} schoolId={parseInt(effectiveSchoolId)} siteUserId={siteUserId} reviewTypes={reviewTypes} product={product} manufacturerName={productLine?.manufacturer?.name} isTypical={isTypicallayout} openReviewBox={true} hideReviewList={true} typicalLayoutCartId={parseInt(cartId)} />
                                        )}
                                    </div>

                                    {/* @*Shipping area*@ */}
                                    <div className="prod-detail-content-wrap pro-phipping-wrap">
                                        <p className="prod-shipping-est-title">
                                            {productLine &&
                                                productLine.manufacturer &&
                                                productLine.manufacturer.shippingNote}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 
